/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EProcurementPlatform = {
    Ariba: 'ARIBA',
    Basware: 'BASWARE',
    ConnectionExpertise: 'CONNECTION_EXPERTISE',
    Coupa: 'COUPA',
    Determine: 'DETERMINE',
    Fieldglass: 'FIELDGLASS',
    Ivalua: 'IVALUA',
    Lbc: 'LBC',
    Obms: 'OBMS',
    Popay: 'POPAY',
    Sap: 'SAP',
    Secoia: 'SECOIA',
    Synertrade: 'SYNERTRADE'
} as const;
export type EProcurementPlatform = typeof EProcurementPlatform[keyof typeof EProcurementPlatform];


export function instanceOfEProcurementPlatform(value: any): boolean {
    for (const key in EProcurementPlatform) {
        if (Object.prototype.hasOwnProperty.call(EProcurementPlatform, key)) {
            // @ts-ignore
            if (EProcurementPlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EProcurementPlatformFromJSON(json: any): EProcurementPlatform {
    return EProcurementPlatformFromJSONTyped(json, false);
}

export function EProcurementPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): EProcurementPlatform {
    return json as EProcurementPlatform;
}

export function EProcurementPlatformToJSON(value?: EProcurementPlatform | null): any {
    return value as any;
}

